import { computed } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { ClassWebsite } from "@shared/models/class-website"
import belongsTo from "cc-frontend/helpers/belongs-to"
import hasMany from "cc-frontend/helpers/has-many-collectively"
import type EmberStore from "cc-frontend/services/ember-store"
import { map } from "lodash-es"
import styles from "./units.module.css"

interface Signature {
  Args: {
    dateString: string
    classWebsite: ClassWebsite
    selectedUnitId: string
    selectedCourseId: string
    goToPrevUnit: (unitId: string) => void
    goToNextUnit: (unitId: string) => void
  }
}

export default class ClassWebsiteUnitsComponent extends Component<Signature> {
  readonly styles = styles
  @service("ember-store") declare store: EmberStore

  @hasMany("args.classWebsite", "course", "courses") courses
  @belongsTo("args.classWebsite", "planbook") planbook
  @belongsTo("planbook", "rotationCalendar") rotationCalendar

  @computed("classWebsite.relationships.courses.data")
  get classWebsiteCourseIds() {
    if (this.args.classWebsite === undefined) return []
    return map(this.args.classWebsite.relationships.courses.data, (course) => course.id)
  }
}
declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::ClassWebsite::Units": typeof ClassWebsiteUnitsComponent
  }
}
